interface ClassificationRange {
  pollution: [number, number];
}

interface IndustrialGrade {
  [industrial_grade: number]: ClassificationRange;
}

interface CottonValidationMap {
  [cotton_class: string]: IndustrialGrade;
}

export const cottonClassificationMap: CottonValidationMap = {
  1: {
    1: { pollution: [0, 3.0] },
    2: { pollution: [0, 5.0] },
    3: { pollution: [0, 8.0] },
    4: { pollution: [0, 12.0] },
  },
  2: {
    1: { pollution: [3.1, 10.0] },
    2: { pollution: [5.1, 10.0] },
    3: { pollution: [8.1, 12.0] },
    4: { pollution: [12.1, 16.0] },
  },
  3: {
    1: { pollution: [10.1, 16.0] },
    2: { pollution: [10.1, 16.0] },
    3: { pollution: [12.1, 18.0] },
    4: { pollution: [16.1, 20.0] },
    5: { pollution: [20.1, 22.0] },
  },
};
